import { useAppSelector } from 'store/store';
import {
  ROLE_SUPER_ADMIN,
  ROLE_TENANT_ADMIN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR
} from 'shared/permissions/roles';

export function IsTenantTechnicianCoordinatorOrAbove({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (
    groups &&
    (groups.includes(ROLE_TENANT_TECHNICIAN_COORDINATOR) ||
      groups.includes(ROLE_TENANT_ADMIN) ||
      groups.includes(ROLE_SUPER_ADMIN))
  )
    return children;
}
